// app/javascript/controllers/show_spinner_on_submit_controller.js
import { Controller } from "@hotwired/stimulus"

/**
 * Usage:
 *  data-controller="show-spinner-on-submit"
 *  data-show-spinner-on-submit-forms-selector-value="#orders_form,#orders_form_mobile"
 *  data-show-spinner-on-submit-spinner-selector-value="#orders_spinner"
 *  data-show-spinner-on-submit-hidden-content-selector-value=".orders"
 */
export default class extends Controller {
  static values = {
    formsSelector: String,
    containerSelector: String,
  }

  connect() {
    this._onSubmit = this._onSubmit.bind(this)

    this._submitting = false
    this._boundForms = []

    this._bindToForms()
  }

  disconnect() {
    this._unbindFromForms()
  }

  _bindToForms() {
    const selector = (this.formsSelectorValue || "").trim()
    if (!selector) return

    const forms = document.querySelectorAll(selector)
    this._boundForms = Array.from(forms)
    this._boundForms.forEach((form) => {
      form.addEventListener("submit", this._onSubmit, { capture: false })
    })
  }

  _unbindFromForms() {
    this._boundForms.forEach((form) => {
      form.removeEventListener("submit", this._onSubmit, { capture: false })
    })
    this._boundForms = []
  }

  _onSubmit(event) {
    if (!this._boundForms.includes(event.target)) return

    if (this._submitting) return

    queueMicrotask(() => {
      if (event.defaultPrevented) {
        this._setLoading(false)
      }
    })

    this._submitting = true
    this._setLoading(true)
  }

  _setLoading(isLoading) {
    const containerElement = this._containerElement();
    containerElement.classList[isLoading ? 'add' : 'remove']('loading')
    this.element.setAttribute("aria-busy", isLoading ? "true" : "false")
  }

  _containerElement() {
    const selector = (this.containerSelectorValue || "").trim()
    if (!selector) return null
    return document.querySelector(selector)
  }
}
